import type { NarrativeClusterManagementActions } from "./narrative-cluster-management.actions";

/**
 * Modal state for narrative cluster operations (delete, rename - single and multi)
 */
export type BulkActionMode = "merge" | "delete" | null;

export type NarrativeClusterManagementModalState = {
  isNarrativeClusterDeleteModalOpen: boolean;
  isRenameClusterModalOpen: boolean;
  isBulkMergeAndDeleteModalOpen: boolean;
  bulkActionMode: BulkActionMode; // Tracks which action (merge/delete) the modal is handling
  selectedClusterId: string | null; // For single delete/rename
  selectedClusterIds: Set<string>; // For multi delete
  clusterName: string | null;
  isDeletingNarrativeCluster: boolean;
  isRenamingCluster: boolean;

  // LLM Perception Modal
  isLlmPerceptionModalOpen: boolean;
  llmPerceptionClusterId: string | null; // The narrative cluster ID for the LLM Perception modal
};

/**
 * Initial state for narrative cluster management
 */
export const narrativeClusterManagementInitialState: NarrativeClusterManagementModalState =
  {
    isNarrativeClusterDeleteModalOpen: false,
    isRenameClusterModalOpen: false,
    isBulkMergeAndDeleteModalOpen: false,
    bulkActionMode: null,
    selectedClusterId: null,
    selectedClusterIds: new Set(),
    clusterName: null,
    isDeletingNarrativeCluster: false,
    isRenamingCluster: false,

    // LLM Perception Modal
    isLlmPerceptionModalOpen: false,
    llmPerceptionClusterId: null,
  };

/**
 * State for managing narrative cluster operations (delete, rename, merge, move).
 * This slice handles UI state (modals, loading) for mutations.
 * Data fetching is handled by useDynamicFilters hook.
 */
export type NarrativeClusterManagementSlice =
  NarrativeClusterManagementModalState & NarrativeClusterManagementActions;
